var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnmute = function SvgUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#07818C",
    fillRule: "evenodd",
    d: "M6 13a3 3 0 0 1 3-3h8.757l7.122-7.121A3 3 0 0 1 30 5v26a3 3 0 0 1-4.975 2.258L17.873 27H9a3 3 0 0 1-3-3zm13 11 5 4.375L27 31V5l-3 3-5 5H9v11h10",
    clipRule: "evenodd"
  })));
};
export default SvgUnmute;